<template>
  <llp-page
    id="datatable-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
        <div class="rental-row">
      <div class="card m-2 m-lg-3">
        <div class="card-body">
          <div class="row d-flex align-items-center ">
            <h5 class="col mb-4 ms-lg-3">Support Reply</h5>
            <div class="col-lg-1 col-md-3 col-sm-3 mb-4">
              <llp-button
                :load-spinner="showaddUserSpinner"
                classNames="btn-secondary"
                type="button"
                @click="handleEditClick()"
              >
                Edit
              </llp-button>
            </div>
            <div class="col-lg-2 col-sm-5 col-md-5 mb-4">
              <llp-button
                :load-spinner="showaddUserSpinner"
                classNames="btn-secondary"
                type="button"
                @click="BackToComplaints()"
              >
                Back to support
              </llp-button>
            </div>
          </div>
          <div class="row ms-lg-2 ms-md-1">
            <div class="row ">
              <!-- First Column for the first h6 tag -->
              <div class="col-lg-6 col-md-6 col-sm-12">
                <h6 class="fs-6">
                  Reply Ticket - {{ this.ticket_details.ticket_no }}
                </h6>
              </div>

              <!-- Second Column for the second h6 tag -->
              <div class="col-lg-6 col-md-6 col-sm-12">
                <h6 class="fs-5 ms-3" v-if="shownComments">Replies</h6>
              </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="row gy-4">
                <div class="col-lg-6 col-md-6 col-sm-6 mb-4">
                  <div class="row mb-4">
                    <div class="card edit-complaint-card">
                      <div class="card-body">
                        <div class="d-flex justify-content-start">
                          <p
                            class="fs-6 ms-2 ticket_priority"
                            v-if="this.ticket_details.priority"
                          >
                            {{ this.ticket_details.priority }}
                          </p>
                        </div>
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <p class="fs-6 mb-0 ms-2 fw-bold">
                            {{ this.ticket_user_name }}
                          </p>
                          <p class="fs-6 mb-0 ms-2 d-flex justify-content-end">
                            {{ formatDate(new Date(this.created_date)) }}
                          </p>
                        </div>
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <p class="fs-6 mb-0 ms-2">{{ this.ticket_email }}</p>
                          <p
                            class="fs-6 ms-2 d-flex justify-content-end ticket_status"
                            v-if="this.ticket_details.status"
                          >
                            {{ this.ticket_details.status }}
                          </p>
                        </div>
                        <hr style="border: 1px solid #ccc" />
                        <p class="fs-6 ms-2">
                          {{ decodeMessage(this.ticket_reply) }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="card edit-complaint-card">
                      <div class="card-body">
                        <h6 class="fs-5 ms-2">Comments</h6>
                        <textarea
                          id="comments"
                          v-model="newComment"
                          :placeHolder="'Your Comments'"
                          class="form-control ms-2"
                        ></textarea>
                        <div
                          v-if="commentValidator.newComment.$invalid"
                          class="text-danger m-2"
                        >
                          {{ commentValidator.newComment.$errors[0]?.$message }}
                        </div>
                      </div>
                      <div class="m-4">
                        <llp-button
                          classNames="btn-secondary"
                          @click="addComments"
                        >
                          Send
                        </llp-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-lg-6 col-md-6 col-sm-6 mb-4"
                  v-if="shownComments"
                >
                  <div class="d-flex flex-column">
                    <div
                      v-for="(reply, index) in this.ticket_replies"
                      :key="index"
                    >
                      <div
                        :key="groupIndex"
                        class="card mb-4 edit-complaint-card"
                      >
                        <div class="card-body">
                          <div
                            class="d-flex justify-content-between align-items-center"
                          >
                            <div class="d-flex align-items-center">
                              <img
                              v-if="this.image || !this.image == null"
                                :src="this.image"
                                alt="user"
                                width="45px"
                                height="45px"
                              
                              />
                                <i v-else class="fas fa-user-circle profile-pic"></i>
                              <p class="fs-6 mb-0 ms-3 fw-bold">
                                {{ reply.user_name }}
                              </p>
                            </div>
                            <p
                              class="fs-6 mb-0 ms-2 d-flex justify-content-end"
                            >
                              {{ formatDate(new Date(reply.created_at)) }}
                            </p>
                          </div>
                          <p class="fs-6 mb-4 ms-5">{{ reply.email }}</p>
                          <hr style="border: 1px solid #ccc" />
                          <p class="fs-6 ms-5">
                            {{ decodeMessage(reply.message) }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Dialog
          v-model:visible="visible"
          modal
          header="Edit support"
          :style="{ width: '50rem' }"
          class="dialog"
        >
          <div class="row">
            <form>
              <div class="row">
                <div class="col-lg-12 col-md-6 col-sm-6 mt-4">
                  <llp-label id="subject" :aria-label="BusinessAddress">
                    Subject:
                  </llp-label>
                  <llp-input
                    id="subjectinputid"
                    :placeHolder="'Subject'"
                    v-model="this.newTicket.subject"
                    :errors="ticketValidator.newTicket.subject.$errors"
                  >
                  </llp-input>
                </div>
              </div>
              <div class="row mt-2">
                 <div class="col-lg-6 col-md-6 col-sm-6">
                    <llp-label id="label-priority">Priority</llp-label>
                    <select id="priority" class="form-control select-dropdown" v-model="newTicket.priority">
                      <option value="" selected disabled>Select</option>
                      <option value="Low">Low</option>
                      <option value="Medium">Medium</option>
                      <option value="High">High</option>
                      <option value="Critical">Critical</option>
                    </select>
                    <div v-if="ticketValidator.newTicket.priority.$invalid" class="text-danger">
                      {{ ticketValidator.newTicket.priority.$errors[0]?.$message }}
                    </div>
                  </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <llp-label id="label-priority" :aria-label="priority">
                    Status
                  </llp-label>
                  <select
                    id="status"
                    class="form-control select-dropdown"
                    v-model="newTicket.status"
                  >
                    <option value="Open">Open</option>
                    <option value="On Hold">On Hold</option>
                    <option value="Closed">Close</option>
                  </select>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-lg-12 col-md-8 col-sm-6">
                  <llp-label id="label-comments" :aria-label="comments">
                    Description:
                  </llp-label>
                  <textarea
                    id="comments"
                    :placeHolder="'Comments'"
                    class="form-control"
                    v-model="newTicket.description"
                  ></textarea>
                  <div
                    v-if="ticketValidator.newTicket.description.$invalid"
                    class="text-danger"
                  >
                    {{
                      ticketValidator.newTicket.description.$errors[0]?.$message
                    }}
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-lg-6 col-md-6 col-sm-6">
                  <llp-label id="subject" :aria-label="BusinessAddress">
                    Attachment:
                  </llp-label>
                  <llp-input
                    id="attachmentinputid"
                    :placeHolder="'Attachment'"
                    type="file"
                    @change="validateFileType"
                    v-model="file"
                  ></llp-input>
                  <div v-if="invalidFileType" class="text-danger">
                    Only .jpg and .png files are allowed.
                  </div>
                </div>
              </div>
              <div class="d-flex submit-newcomplaint mt-4">
                <llp-button classNames="btn-secondary" @click="updateTicket">
                  Submit
                </llp-button>
              </div>
            </form>
          </div>
          <br /><br />
        </Dialog>
      </div>
        </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import ErrorService from "../../../services/error.service";
import NetworkService from "../../../services/network.service.js";
import Dialog from "primevue/dialog";

export default {
  components: {
    Dialog,
  },

  setup() {
    const commentValidator = useVuelidate();
    const ticketValidator = useVuelidate();

    return { commentValidator, ticketValidator };
  },
  
  // mounted() {
  //   // this.fetchTicketsDetails();
  //   // this.fetchEditComplaintDetails();
  //         if (window.location.href === `http://localhost:8080/reply-complaint/${this.id}`) {

  //       this.interval = setInterval(() => {
  //         this.fetchTicketsDetails();
  //       }, 2000);
  //     } else {
  //       console.log("Not on the specific page");
  //     }
  // },
  data() {
    return {
      newComment: "",
      replies: [],
      shownComments: false,
      id: this.$route.params.id,
      user_id: localStorage.getItem("User_id"),
      visible: false,
      ticket_email: "",
      ticket_user_name: "",
      ticket_number: "",
      ticket_details: "",
      created_date: "",
      ticket_reply: "",
      ticket_replies: "",
      file: "",
      newTicket: {
        priority: "",
        status: "",
        subject: "",
        description: "",
        attachment: "",
      },
    };
  },
  mounted() {
    this.checkPageAndStartInterval();
    this.fetchTicketsDetails();
  },

  watch: {
    $route() {
      this.checkPageAndStartInterval();
    },
  },
  validations() {
    return {
      newComment: {
        required: helpers.withMessage("Comment is required.", required),
      },
      newTicket: {
        subject: {
          required: helpers.withMessage("Subject is required.", required),
        },
        priority: {
          required: helpers.withMessage("Priority is required", required),
        },
        // dateRange: {
        //   required: helpers.withMessage("Date is required", required),
        // },
        // attachment: {
        //   required: helpers.withMessage("Attachment is required.", required),
        // },
        description: {
          required: helpers.withMessage("Description is required.", required),
        },
      },
    };
  },
  methods: {
    handleEditClick() {
      this.visible = true;
      this.fetchEditComplaintDetails();
    },
    decodeMessage(message) {
      return decodeURIComponent(message);
    },
    validateFileType(event) {
      const file = event.target.files[0];

      if (file) {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        if (fileExtension !== "jpg" && fileExtension !== "png") {
          this.invalidFileType = true;
          this.newTicket.attachment = "";
        } else {
          this.invalidFileType = false;
        }
      }
    },
    formatDate(date) {
      if (!date || isNaN(date)) {
        return "";
      }
      const options = { year: "numeric", month: "short", day: "numeric" };
      return date.toLocaleDateString("en-US", options);
    },

    async fetchTicketsDetails() {
      try {
        const ticketResponse = await NetworkService.get(
          `tickets/replies/${this.id}`
        );

        this.ticket_details = ticketResponse.data;

        this.ticket_replies = ticketResponse.data.replies;

        // Check if there's more than one reply, only then show the replies section
        if (this.ticket_replies.length > 0) {
          if (this.ticket_replies.length === 1) {
            this.shownComments = false;
          } else {
            this.shownComments = true;
          }
          this.ticket_email = this.ticket_replies[0].email;
          this.ticket_user_name = this.ticket_replies[0].user_name;
          this.created_date = this.ticket_replies[0].created_at;
          this.ticket_reply = this.ticket_replies[0].message;
          this.image = this.ticket_replies[0].image;
        }

      } catch (error) {
        if (error.message) {
          this.$refs.toast.show(
            "Unable to fetch details of tickets,Please wait for sometime.",
            "error"
          );
        } else {
          this.$refs.toast.show(ErrorService.getErrorMessages(error), "error");
        }
      }
    },

    async addComments() {
      await this.commentValidator.$validate();
      if (this.commentValidator.newComment.$invalid) {
        return;
      }
      try {
        const encodedMessage = encodeURIComponent(this.newComment);
        const addNewCommentResponse = await NetworkService.post(
          `tickets/reply/${this.id}?support_ticket_id=${this.id}&message=${encodedMessage}&user_id=${this.user_id}`
        );
        this.$refs.toast.show(addNewCommentResponse.data.message);
        this.fetchTicketsDetails();
        this.newComment = "";
        this.commentValidator.newComment.$reset();
      } catch (error) {
        this.$refs.toast.show(
          "Unable to add the comments. Please try again later.",
          "error"
        );
      }
    },

    async updateTicket() {
      // Validate the form using the ticketValidator
      await this.ticketValidator.$validate();
      if (this.ticketValidator.newTicket.$invalid) {
        return;
      }

      const formData = new FormData();
      formData.append("subject", this.newTicket.subject);
      formData.append("priority", this.newTicket.priority);
      formData.append("status", this.newTicket.status);
      formData.append("description", this.newTicket.description);
       formData.append("_method", "PUT");
      const fileInput = document.querySelector("#attachmentinputid");
      const file = fileInput?.files[0];
      if (file) {
        formData.append("attachment", file);
      } else {
        console.error("No file selected.");
      }

      try {
        const newTicketResponseData = await NetworkService.post(
          `support-tickets/${this.id}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" }, },
          
        );

        this.$refs.toast.show(newTicketResponseData.data.message);
        setTimeout(() => {
          this.$router.push(`/user-support`);
        }, 1500);
      } catch (error) {
        // Error handling
        if (error.message) {
          this.$refs.toast.show(
            "Unable to update the ticket details. Please wait for a moment.",
            "error"
          );
        } else {
          // Show custom error messages from an external service
          this.$refs.toast.show(ErrorService.getErrorMessages(error), "error");
        }
      }
    },

    async fetchEditComplaintDetails() {
      try {
        const editComplaintReponse = await NetworkService.get(
          `support-tickets/${this.id}`
        );
        this.newTicket.subject = editComplaintReponse.data.subject;
        this.newTicket.priority = editComplaintReponse.data.priority;
        this.newTicket.status = editComplaintReponse.data.status;
        this.newTicket.attachment = editComplaintReponse.data.attachments;
        if (editComplaintReponse.data.responses.length > 0) {
          this.newTicket.description =
            editComplaintReponse.data.responses[0].description;
        }
      } catch (error) {
        if (error.message) {
          this.$refs.toast.show(
            "Unable to fetch the ticket details, Please wait for a while.",
            "error"
          );
        } else {
          this.$refs.toast.show(ErrorService.getErrorMessages(error), "error");
        }
      }
    },

    BackToComplaints() {
      this.$router.push("/user-support");
    },

    checkPageAndStartInterval() {
      if (this.$route.path === `/reply-complaint/${this.id}`) {
        this.fetchTicketsDetails();
        if (!this.interval) {
          this.interval = setInterval(() => {
            this.fetchTicketsDetails();
          }, 2000);
        }
      } else {
        if (this.interval) {
          clearInterval(this.interval);
          this.interval = null;
        }
      }
    },
  },
  beforeUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  },
};
</script>

<style scoped>
</style>

